import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { DocumentoAccredito, Evento, Persona, Spettacolo } from '../../../../shared/interface';
import { Table } from 'primeng/table';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-personale-accrediti-backoffice',
  templateUrl: './personale-accrediti-backoffice.component.html',
  styleUrls: ['./personale-accrediti-backoffice.component.css']
})
export class PersonaleAccreditiBackofficeComponent implements OnInit {

  constructor(
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {}

  @ViewChild('delete') delete!: ConfirmPopup;
  @ViewChild('deleteDocumento') deleteDocumento!: ConfirmPopup;

  @Input() attivita_rischio: boolean = false;
  @Input() personale: Persona[] = [];
  @Input() evento?: Evento;
  @Input() visione: boolean = false

  persona?: Persona;
  spettacolo?: Spettacolo;

  loading: boolean = false;
  add: boolean = false;
  edit: boolean = false;

  readonly emptySubappalti: never[] = [];
  expandedRows = {};
  private notaDraft = new Map<number, string>();

  ngOnInit(): void {      
    
    if (this.evento) {
      this.apiService.getSpettacolo(this.evento.id_spettacolo).subscribe({
        next: (data) => this.spettacolo = data,
        error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
        complete: () => { }
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.attivita_rischio = changes['attivita_rischio']?.currentValue || this.attivita_rischio;
    this.personale = changes['personale']?.currentValue || this.personale;
    this.evento = changes['evento']?.currentValue || this.evento;
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  checkDocumenti(tipo: string, persona: Persona) {
    return persona?.documenti.filter(doc => doc.tipo == tipo).length;
  }

  unilavRequired(persona: Persona): boolean {
    const ruolo = (persona.ruolo || '').toLowerCase().trim();
    const exempt = [
      'direzione di produzione',
      'tour manager',
      'assistente di produzione',
      'altro ruolo organizzativo',
    ];
    if (exempt.includes(ruolo)) return false;
    if (persona.inps && String(persona.inps).trim()) return false;
    return true;
  }

  certificazioniRequired(persona: Persona): boolean {
    return (persona.ruolo || '').toLowerCase().trim() === 'rigger / lavori in quota';
  }

  onOpenDelete(event: Event, persona: Persona) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler rimuovere il membro dal personale autorizzato?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deletePersonale(persona.id).subscribe({
          next: (data) => this.apiService.setPersonaleEvento(this.evento!.id),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.apiService.message("success", "Eliminazione", "Il membro del personale è stato eliminato con successo!")
          }
        })
      },
    });
  }

  onDelete() {
    this.delete.accept();
  }

  onClose() {
    this.delete.reject();
  }

  onOpenEdit(persona: Persona) {
    this.persona = persona;
    this.edit = true;    
  }

  onCloseEdit(close: any) {
    this.edit = false;
    this.persona = undefined;
  }

  onBadge(persona: Persona) {
    this.loading = true;
    // Recupero la ricevuta
    this.apiService.getBadge(persona.id).subscribe({
      next: (data) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.target = '_blank'
        a.href = url;
        a.download = `badge_${persona.cognome}_${persona.nome}.pdf`;
        a.click();
        this.loading = false;
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);       
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    });
  }

  onBadgePersonale() {
    this.loading = true;
    // Recupero i badge
    this.apiService.getBadgePersonale(this.evento?.id!).subscribe({
      next: (data) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.target = '_blank'
        a.href = url;
        a.download = `badge_personale.pdf`;
        a.click();
        this.loading = false;
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);       
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    });
  }

  onDownloadDocumenti() {    

    this.loading = true;

    let documenti: DocumentoAccredito[] = []
    this.personale.map(persona => persona.documenti.map(doc => documenti.push(doc)));

    // Recupero la ricevuta
    this.apiService.getZipDocumenti(documenti).subscribe({
      next: (data) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.target = '_blank'
        a.href = url;
        a.download = `documenti.zip`;
        a.click();
        this.loading = false;
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);       
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err.message)        
      },
    });
  }

  onDownloadDocumentiPersonale(persona: Persona) {
    this.loading = true;
    // Recupero la ricevuta
    this.apiService.getZipDocumenti(persona.documenti).subscribe({
      next: (data) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.target = '_blank'
        a.href = url;
        a.download = `documenti.zip`;
        a.click();
        this.loading = false;
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);       
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err.message)        
      },
    });
  }

  onDownloadDocumentiPersonaleDettaglio(persona: Persona, tipo: string) {
    this.loading = true;

    let documenti = persona.documenti.filter(doc => doc.tipo == tipo);

    // Recupero la ricevuta
    this.apiService.getZipDocumenti(documenti).subscribe({
      next: (data) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.target = '_blank'
        a.href = url;
        a.download = `documenti.zip`;
        a.click();
        this.loading = false;
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);       
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err.message)        
      },
    });
  }

  async onExport() {

    this.loading = true;
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Personale');

    // Larghezza colonne
    sheet.columns = [
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 30 },
    ];

    // Helper per applicare stile header
    const applyHeaderStyle = (cell: ExcelJS.Cell) => {
      cell.font = { bold: true, name: 'Calibri' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFEE00' },        
      };
    };

    // Riga 1 - Titolo SPETTACOLO
    sheet.getRow(1).getCell(1).value = 'SPETTACOLO';
    sheet.getRow(1).eachCell(cell => { applyHeaderStyle(cell) })

    // Riga 2 - Header spettacolo (bold + colore)
    const headerSpettacoloRow = sheet.getRow(2);
    const headersSpettacolo = ['Nome Spettacolo', 'Dal', 'Al'];
    headersSpettacolo.forEach((h, i) => {
      const cell = headerSpettacoloRow.getCell(i + 1);
      cell.value = h;
      applyHeaderStyle(cell);
    });

    // Riga 3 - Dati spettacolo
    sheet.getRow(3).values = [
      this.spettacolo?.spettacolo,
      this.datePipe.transform(this.spettacolo?.dal, 'dd/MM/yyyy'),
      this.datePipe.transform(this.spettacolo?.al, 'dd/MM/yyyy'), // <-- era dal due volte, corretto in "al"
    ];

    // Riga 5 - Titolo PERSONALE
    sheet.getRow(5).getCell(1).value = 'PERSONALE';
    sheet.getRow(5).eachCell(cell => { applyHeaderStyle(cell) })

    // Riga 6 - Header personale (bold + colore)
    const headerPersonaleRow = sheet.getRow(6);
    const headersPersonale = ['Cognome', 'Nome', 'Ruolo', 'Firma'];
    headersPersonale.forEach((h, i) => {
      const cell = headerPersonaleRow.getCell(i + 1);
      cell.value = h;
      applyHeaderStyle(cell);
    });

    // Righe personale
    const personaleOrdinato = this.personale
      .sort((a, b) => a.cognome.localeCompare(b.nome));

    personaleOrdinato.forEach((persona, index) => {
      sheet.getRow(7 + index).values = [
        persona?.cognome,
        persona?.nome,
        persona?.ruolo,
        '',
      ];
    });

    this.loading = false;

    // Esporta
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, 'Personale.xlsx');
  }

  onOpenDeleteDocumento(event: Event, documento: DocumentoAccredito) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler rimuovere il documento dal personale autorizzato?`,
      reject: () => this.confirmationService.close(),
      accept: () => {        
        this.apiService.deleteDocumentoAccredito(documento.id).subscribe({
          next: (data) => this.apiService.setPersonaleEvento(this.evento?.id!),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.apiService.message("success", "Eliminazione", "Il documento del personale è stato eliminato con successo!")
          }
        })
      },
    });
  }

  onDeleteDocumento() {
    this.deleteDocumento.accept();
  }

  onCloseDocumento() {
    this.deleteDocumento.reject();
  }

  onStato(stato: string, persona: Persona) {
    const next = persona.stato === stato ? 'ok' : stato;
    this.loading = true;
    this.apiService.updateValidazionePersonale(persona.id, { stato: next }).subscribe({
      next: () => {
        persona.stato = next;
        if (this.evento?.id) {
          this.apiService.setDocumentiEvento(this.evento.id);
          this.apiService.documentoStatoChanged.next(this.evento.id);
        }
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err?.error?.message?.message || err.message);
      },
      complete: () => { this.loading = false; },
    });
  }

  onNotaDraft(persona: Persona, value: string) {
    this.notaDraft.set(persona.id, value);
  }

  onNotaBlur(persona: Persona) {
    const note = this.notaDraft.has(persona.id) ? this.notaDraft.get(persona.id)! : (persona.note || '');
    if (note === (persona.note || '')) return;
    this.apiService.updateValidazionePersonale(persona.id, { note: note || null }).subscribe({
      next: () => {
        persona.note = note;
        this.apiService.message('success', 'Note', 'Nota aggiornata');
      },
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || err.message),
    });
  }

}
